import { render, staticRenderFns } from "./GlyphsTab.vue?vue&type=template&id=54c8d7e6&scoped=true&"
import script from "./GlyphsTab.vue?vue&type=script&lang=js&"
export * from "./GlyphsTab.vue?vue&type=script&lang=js&"
import style0 from "./GlyphsTab.vue?vue&type=style&index=0&id=54c8d7e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c8d7e6",
  null
  
)

export default component.exports